module.exports = __webpack_public_path__ + "assets/img/structure-61c79309.png";